export const EMAIL_FORMAT_ERROR = "El formato del correo electrónico no es válido";
export const EMAIL_REQUIRED_ERROR = "Este campo es requerido.";
export const EMAIL_VERIFICATION_ERROR =
  "No se pudo validar el correo electrónico. Intenta nuevamente.";
export const EMAIL_SAVE_ERROR =
  "El correo electrónico del representante legal presenta un error de validación. Al continuar, la solicitud se guardará como borrador sin este dato. Podrás corregirlo posteriormente.";
